import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, provide, ref, watch } from 'vue';
import RegisterLoginPopup from './view/loginRegister/registerLoginPopup.vue';
import { playClickSound } from './utils/media';
import { useThemeStore } from './stores/theme';
import { useUserStore } from './stores/user';
import LogoutPopupOne from './themes/themeOne/profile/components/logoutPopup.vue';
import LogoutPopupTwo from './themes/themeTwo/profile/components/logoutPopup.vue';
import LogoutPopupThree from './themes/themeThree/profile/components/logoutPopup.vue';
import LogoutPopupFour from './themes/themeFour/profile/components/logoutPopup.vue';
import { subscribeUserToPush } from './utils/push';
import { useRoute } from 'vue-router';
import { initFacebookPixel } from './utils/facebookTracking';

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const logOutRef = ref()
const registerRef = ref()
const themeStore = useThemeStore()
const userStore = useUserStore()

const route = useRoute();
const scrollContainer = ref<HTMLElement | null>(null);
provide('openLogoutPopup', () => {
  logOutRef.value.open()
});

provide('openRegisterLoginPopup', (type: number) => {
  playClickSound()
  registerRef.value.open(type)
});

(window as any).openLoginPopup = (type: number) => {
  playClickSound();
  registerRef.value.open(type);
};

const updateFavicon = (themeIndex: number) => {
  let faviconUrl = '';
  try {
    if (themeIndex === 1) {
      faviconUrl = new URL('@/assets/home/APP_gold.png', import.meta.url).href;
    } else if (themeIndex === 2) {
      faviconUrl = new URL('@/assets/themetwo/logo2.png', import.meta.url).href;
    } else if (themeIndex === 3) {
      faviconUrl = new URL('@/assets/themeThree/logo.png', import.meta.url).href;
    } else if (themeIndex === 4) {
      faviconUrl = new URL('@/assets/themeFour/APP6.png', import.meta.url).href;
    } else {
      faviconUrl = '/head_icon.jpg';
    }

    const links = document.querySelectorAll("link[rel*='icon']");
    links.forEach(link => {
      (link as HTMLLinkElement).href = faviconUrl;
    });
  } catch (error) {
    console.error("Error updating favicon:", error);
  }
}
const applyBodyBackground = () => {
  if (themeStore.themeIndex === 1) {
    document.body.style.backgroundColor = '#27190d'
  } else if (themeStore.themeIndex === 2) {
    document.body.style.backgroundColor = 'rgb(49, 39, 52)'
  } else if (themeStore.themeIndex === 3) {
    document.body.style.backgroundColor = '#090F1F'
  } else if (themeStore.themeIndex === 4) {
    document.body.style.backgroundColor = 'rgb(0, 97, 96)'
  } else {
    document.body.style.backgroundColor = '#27190d'
  }
}
// Watch for user login to subscribe to push notifications
watch(() => userStore.id, (newId, oldId) => {
  if (newId && !oldId) {
    subscribeUserToPush();
  }
}, { immediate: true }); // Use immediate to check on initial load

watch(() => themeStore.themeIndex, (newIndex) => {
  applyBodyBackground();
  updateFavicon(newIndex);
}, { immediate: true });

watch(() => route.path, () => {
  if (scrollContainer.value) {
    scrollContainer.value.scrollTop = 0;
  }
});
const appStyle = computed(() => {
  let style: Record<string, string> = {};

  if (themeStore.themeIndex === 1) {
    style.backgroundImage = `url(${new URL('@/assets/main_bg.png', import.meta.url).href})`;
    style.backgroundSize = 'cover';
    style.backgroundRepeat = 'repeat';
    style.backgroundColor = '#27190d';
  } else if (themeStore.themeIndex === 2) {
    style.backgroundColor = '#221b24';
    style.backgroundImage = 'none';
    style.backgroundSize = 'cover';
    style.backgroundRepeat = 'repeat';
  } else if (themeStore.themeIndex === 3) {
    style.backgroundColor = '#090f1f';
    style.backgroundImage = `url(${new URL('@/assets/texture_bg.png', import.meta.url).href})`;
    style.backgroundSize = 'initial';
    style.backgroundRepeat = 'repeat';
  } else if (themeStore.themeIndex === 4) {
    style.backgroundColor = '#002d2d';
    style.backgroundImage = 'none';
    style.backgroundSize = 'cover';
    style.backgroundRepeat = 'repeat';
    style.fontFamily = 'system-ui';
  } else {
    style.backgroundColor = '#27190d';
    style.backgroundImage = `url(${new URL('@/assets/main_bg.png', import.meta.url).href})`;
    style.backgroundSize = 'cover';
    style.backgroundRepeat = 'repeat';
  }

  return style;
});
onMounted(() => {
  applyBodyBackground()
  initFacebookPixel()
})

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    style: _normalizeStyle(appStyle.value)
  }, [
    _createElementVNode("div", {
      class: "scroll-container",
      ref_key: "scrollContainer",
      ref: scrollContainer
    }, [
      _createVNode(_Transition, {
        name: "slide-left",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_RouterView)
        ]),
        _: 1
      })
    ], 512),
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createBlock(LogoutPopupOne, {
          key: 0,
          ref_key: "logOutRef",
          ref: logOutRef
        }, null, 512))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createBlock(LogoutPopupTwo, {
          key: 1,
          ref_key: "logOutRef",
          ref: logOutRef
        }, null, 512))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createBlock(LogoutPopupThree, {
          key: 2,
          ref_key: "logOutRef",
          ref: logOutRef
        }, null, 512))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 4)
      ? (_openBlock(), _createBlock(LogoutPopupFour, {
          key: 3,
          ref_key: "logOutRef",
          ref: logOutRef
        }, null, 512))
      : _createCommentVNode("", true),
    _createVNode(RegisterLoginPopup, {
      ref_key: "registerRef",
      ref: registerRef
    }, null, 512)
  ], 4))
}
}

})